// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3urJW","content":"ManualTimeModal_content__1YX8E"};